import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import { history } from 'store';
import {
  LOADING,
  ASYNC_CREATE_EVENT,
  ASYNC_EDIT_EVENT,
  ASYNC_CREATE_EVENT_EXTRA_MATERIAL,
  ASYNC_EDIT_EVENT_EXTRA_MATERIAL,
  ASYNC_DELETE_EVENT,
  ASYNC_RESTORE_EVENT,
  ASYNC_FINISH_EVENT
} from 'store';
import swal from '../../helpers/swal'

function* createEvent({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    const response = yield call(api.post, 'events', payload, {
      headers: {
        'X-Success-Message': 'Evento cadastrado com sucesso!',
        // 'X-Redirect': `/events/`,
        'X-Show-Alert': true
      }
    });
    window.location.href = `/events/edit/${response.data.id}`;
    // const response = yield call(api.post, 'events', payload);
    // yield swal(
    //   'Sucesso', 
    //   `Evento cadastrado com sucesso!`,
    //   'success',
    //   3000,
    //   `/events/`,
    //   history
    // );
  } catch (error) {
    yield swal('Ops!', error.response.data[0], 'error');
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* createEventExtraMaterial({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.post, 'extra-materials', payload);
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editEventExtraMaterial({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield payload.append('_method', 'PUT');
    yield call(api.post, `extra-materials/${payload.get('id')}`, payload);
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editEvent({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield payload.append('_method', 'PUT');
    const response = yield call(api.post, `events/${payload.get('id')}`, payload, {
      headers: {
        'X-Success-Message': 'Evento atualizado com sucesso!',
        // 'X-Redirect': `/events/`,
        'X-Show-Alert': true
      }
    });
    window.location.href = `/events`;
  } catch (error) {
    yield swal('Ops!', error.response.data[0], 'error');
  } finally {
    yield put({ type: LOADING, payload: false });
  }

  // try {
  //   yield payload.append('_method', 'PUT');
  //   yield call(api.post, `events/${payload.get('id')}`, payload);
  //   yield swal(
  //     'Sucesso', 
  //     'Evento atualizado com sucesso',
  //     'success',
  //     3000,
  //     '/events',
  //     history
  //   );
  // } catch (error) {
  //   yield swal('Ops!', error.response.data[0], 'error');
  // } finally {
  //   yield put({ type: LOADING, payload: false });
  // }
}

function* deleteEvent({ payload: { id } }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.delete, `events/${id}`, {
      headers: {
        'X-Success-Message': 'Evento inativado com sucesso', 
        'X-Redirect': '/events',
        'X-Refresh': true,
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* restoreEvent({ payload: { id } }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.get, `events/restore/${id}`, {
      headers: {
        'X-Success-Message':'Evento restaurado com sucesso', 
        'X-Redirect': '/events/trash',
        'X-Refresh': true,
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* finishEvent({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {    
    yield payload.append('_method', 'PUT');
    yield call(api.post, `events/${payload.get('id')}/update-status`, payload,  {
      headers: {
        'X-Success-Message':'Evento finaliazdo com sucesso', 
        'X-Redirect': '/events',
        'X-Refresh': true,
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

export default function* root() {
  yield all([
    takeLatest(ASYNC_CREATE_EVENT, createEvent),
    takeLatest(ASYNC_EDIT_EVENT, editEvent),
    takeLatest(ASYNC_CREATE_EVENT_EXTRA_MATERIAL, createEventExtraMaterial),
    takeLatest(ASYNC_EDIT_EVENT_EXTRA_MATERIAL, editEventExtraMaterial),
    takeLatest(ASYNC_DELETE_EVENT, deleteEvent),
    takeLatest(ASYNC_RESTORE_EVENT, restoreEvent),
    takeLatest(ASYNC_FINISH_EVENT, finishEvent),
  ]);
}
